export const selfImage = "/assets/jpg/self.jpg";